

export const isLoading = (state) => {
  return state.isLoading
}

// export const getGrandprizeOnly =(state) => {
//   const grandprizes = state.prizes.filter(prize => prize.type === 'gp')[0]
//   return grandprizes
// }